import { render } from "./CurrentUser.vue?vue&type=template&id=1fb0e13d"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"
script.render = render

export default script